<template>
  <div class="savePoster">
    <div class="savePoster-text">
      <p @click="copyInviteMsg()">一键复制邀请语</p>
    </div>
    <div class="savePoster-poster">
      <div class="savePoster-title">
        {{ this.posterActiveIndex >= this.posterList.length ? '制作个性化海报' : '主题海报'}} {{this.posterActiveIndex + 1}}/{{this.posterList.length + 1}}
      </div>
      <swiper class="savePoster-swiper" :options="swiperOption">
        <swiper-slide  v-for="item in posterList" :key="item.id">
          <div class="savePoster-choose">
            <img :src="item.img" :data-poster="item.id"
              @touchstart="touchStart"
              @touchmove="touchMove"
              @touchend="touchEnd" />
          </div>
        </swiper-slide>
        <!-- 上传：制作个性海报 -->
        <swiper-slide>
          <div class="savePoster-choose">
            <div class="savePoster-choose-con">
              <img src="../assets/images/bg-saveposter-create.png" alt />
              <PhotoUploader class="savePoster-uploader" ref="photoUploader" @afterUploader="afterUploader"></PhotoUploader>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div v-show="posterActiveIndex >= this.posterList.length" class="savePoster-create" @click="uploadPosterImg()">
      <img src="../assets/images/btn-create-poster.png" alt="开始制作专属邀请海报">
    </div>
    <imgShare v-show="posterActiveIndex < this.posterList.length"
      :imgUrl="posterUrl_default_normal"
      @shareClick="handleShareClick"
      @appShareBack="handleAppShareBack" />
    <template v-if="posterList.length < 3 && defaultList.length">
      <CanvasPoster v-for="(item, idx) in defaultList" :key="idx" class="savePoster-createPoster"
        :id="idx"
        :poster-id="item.Tag"
        :bg-img="item.Url"
        :qr-code="item.qrcode"
        @posterDrawed="handlePosterDrawed" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import 'swiper/dist/css/swiper.css'
import Clipboard from '../utils/clipBoard'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import imgShare from '@/inviteNew/components/ImgShare'
import { mixin_qrcode_miniProgram } from '../mixin/mixin'
import CanvasPoster from '@/inviteNew/components/CanvasPoster' // 海报生成
import PhotoUploader from '@/inviteNew/components/PhotoUploader'

export default {
  name: 'savePoster',
  computed: mapState(['userInfo']),
  mixins: [mixin_qrcode_miniProgram],
  components: {
    swiper,
    imgShare,
    swiperSlide,
    CanvasPoster,
    PhotoUploader
  },
  data () {
    // eslint-disable-next-line
    const _that = this
    return {
      defaultList: [],
      tutorId: '', // 辅导老师id
      timeoutId: null,
      posterList: [], // 合成的默认海报 地址
      posterActiveIndex: 0,
      imgCanvasList: new Set(),
      posterUrl_default_normal: '', // 常规老带新 默认海报图片 地址
      inviteMsg: '最近孩子一直在学而思网校上课，课上有名师教分析思维，课前课后有辅导老师贴心指导，孩子喜欢我也就放心了。强力安利给大家！扫码立减100。',
      swiperOption: {
        isLongPress: false, // 用户是否触发长按事件
        centeredSlides: true,
        slidesPerView: 'auto',
        on: { // 监听swiper的滑动操作
          slideChange: function () {
            const activeIndex = this.activeIndex
            _that.posterActiveIndex = activeIndex
            // 最后swide 个性海报，数组长度不足
            _that.posterUrl_default_normal = _that.posterList[activeIndex] ? _that.posterList[activeIndex].img : ''
          }
        }
      }
    }
  },
  created () {
    const { tutorId } = this.$route.query
    const posterList = localStorage.getItem('posterList')
    this.tutorId = tutorId || ''
    this.$toast.loading({ message: '海报生成中...', duration: 0 })
    // 提前获取个性二维码
    // this.setQRCode(0, true)
    if (posterList) {
      this.posterList = JSON.parse(posterList)
      this.$toast && this.$toast.clear()
      return
    }
    this.$api.getDefaultPoster().then(async res => {
      if (res.code === 0) {
        // this.defaultList = res.data.list
        let flag = 0
        const tem = res.data.list
        while (flag < tem.length) {
          console.log('flag', flag)
          const qrcode = await this.setQRCode(0, true, flag + 1)
          tem[flag].qrcode = qrcode
          flag++
          console.log('flag-end', flag)
          if (flag >= 3) {
            console.log(JSON.parse(JSON.stringify(tem)))
            this.defaultList = tem
          }
        }
      }
    })
  },
  // 页面销毁生命周期
  destroyed () {
    console.log('destroyed')
    // 返回首页或进去其它页面
    this.$toast && this.$toast.clear()
  },
  methods: {
    /**
     * 右上角 一键复制邀请语
     */
    copyInviteMsg () {
      this.$xesLogger.clickMsg({ params: { action: 'copyInviteMsg', clickid: '5.3.12' } })
      const copyResult = Clipboard.copy(this.inviteMsg)
      const messageTips = copyResult ? '复制成功，快去邀请好友吧！' : '当前环境不支持，请通过海报分享'
      return this.$toast(messageTips)
    },
    // 开始制作专属海报按钮 点击。通过触发 图片/拍照 按钮的点击事件 完成功能。
    uploadPosterImg () {
      this.$refs.photoUploader.$refs.input.click()
      this.$xesLogger.clickMsg({ params: { action: 'uploadPosterImg', clickid: '5.3.17' } })
    },
    // 海报图片按下, 设置长按保存图片埋点
    touchStart () {
      this.isLongPress = false
      this.timeoutId = setTimeout(() => {
        this.isLongPress = true
        this.$xesLogger.clickMsg({ params: { clickid: '4.1', posterId: this.posterActiveIndex + 1, action: 'longPress' } })
      }, 600)
    },
    touchMove () {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    },
    touchEnd () {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    },

    /**
     * 海报绘制完成。
     * CreatePoster回调，把海报img url 传回来。
     * v3.0 只有常规老带新，即 id 只会等于 report2
     * @args {string} id - 默认海报id
     * @args {string} img - 生成海报的图片数据(base64)
     */
    handlePosterDrawed (id, img) {
      this.posterList.push({ img })
      if (this.posterList.length >= 3) {
        this.$toast.clear()
        localStorage.setItem('posterList', JSON.stringify(this.posterList))
      }
    },
    // 制作个性海报，图片上传完成  字组件事件
    afterUploader (file) {
      // 把用户上传的图片资源 传递到posterList
      sessionStorage.setItem('uploadImg', file)
      let route = { name: 'posterList' }
      if (this.tutorId) { // 辅导老师带新活动需要携带tutorId
        route = { name: 'posterList', query: { tutorId: this.tutorId } }
      }
      this.$router.push(route)
      this.$xesLogger.clickMsg({ params: { action: 'afterUploader', clickid: '8.3' } })
    },
    // 分享按钮点击（shareFixed 回传）。埋点添加 分享海报数据
    handleShareClick (scence) {
      // app分享图标被点击事件，记录点击触发日志
      this.$xesLogger.clickMsg({
        params: {
          scence,
          clickid: '8.1',
          action: 'handleShareClick',
          posterId: this.posterActiveIndex + 1
        }
      })
    },
    // 分享结果回调 埋点添加 分享海报数据
    handleAppShareBack (data) {
      // 分享的结果回调方法， 1 成功，2 失败，3 取消
      this.$xesLogger.clickMsg({
        elem: document.body,
        params: {
          clickid: '8.2',
          scence: data.scence,
          action: 'handleAppShareBack',
          posterId: this.posterActiveIndex + 1
        }
      })
    }
  },
  // 去到其他页面清楚poster缓存
  beforeRouteLeave (to, from, next) {
    console.log(to, from)
    if (to.name !== 'posterList') {
      localStorage.removeItem('posterList')
    }
    next()
  }
}
</script>

<style lang="less" scoped>
.savePoster {
  width: 100%;
  min-height: 100vh;
  background: url('../assets/images/bg-posterList.png');
  background-size: cover;

  &-text {
    position: fixed;
    top: 40px;
    right: -9px;

    & > p {
      height: 23px;
      padding-left: 9px;
      padding-right: 18px; // 9+9(left)
      font-size: 11px;
      font-weight: 400;
      line-height: 23px;
      color: #fff;
      background: #f2364a;
      border-radius: 12px;
    }
  }

  &-poster {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 90vh;
  }

  .swiper-container {
    width: 100%;
    margin-top: 30px; // 给  一键复制邀请语 留位置
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70vw;
    font-size: 18px;
    text-align: center;
    transition: 300ms;
  }

  .swiper-slide:not(.swiper-slide-active) {
    transform: scale(0.8);
  }

  &-title {
    padding: 14px 0;
    font-size: 13px;
    font-weight: 400;
    color: #333;
  }

  &-create {
    width: 269px;
    height: 50px;
    margin: 0 auto;
    text-align: center;
  }

  &-choose {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .savePoster-qrcode {
      position: absolute;
      bottom: 2.5vh;
      right: 4vw;
      width: 13vw;
      height: 13vw;
    }

    .poster {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    &-con {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  // v3.2 隐藏。全屏图片可点击
  &-uploader {
    position: absolute;
    top: 0;
    display: block !important; // 组件内是inline-block
    width: 100%;
    height: 100%;
  }

  &-createPoster {
    position: absolute;
    top: 0;
    left: -500%;
    display: block !important; // 组件内是inline-block
    width: 100%;
    height: 100%;

    img {
      vertical-align: middle;
    }
  }
}
</style>
